import { Toaster as SonnerToaster } from "sonner";

/* 
  Toaster - This component acts as a provider for the toast notifications in the application.
  It is invoked using the `toast` function.
*/
export const Toaster = () => {
  /* Render */
  return (
    <SonnerToaster
      className="w-full"
      position="bottom-left"
      toastOptions={{
        unstyled: true,
        duration: 5000,
      }}
    />
  );
};
